<template>
  <v-modal v-if="showPopup" @close="this.close()">
    <template v-slot:container>
      <div class="modal-container expired-activities-modal">
        <div class="modal-header">
          <h3>Ongelezen nieuwsbericht</h3>
        </div>
        <div class="modal-body">
          <p>
            Informatie over nieuwsbericht?<br/>
          </p>
        </div>
        <div class="modal-footer">
          <div class="expired-activities-dialog__buttons">
            <button class="btn btn-sandpiper" type="button"
                    @click="openArticle">
              Lees Artikel
            </button>
            <button class="btn btn-sandpiper cancel-activities" type="button"
                    @click="showPopup = false">
              Sluiten
            </button>
          </div>
        </div>
      </div>
    </template>
  </v-modal>
</template>

<script>
import log from "@/utils/logger";
import {NewsApi} from "sandpiper_api";
import VModal from "@/components/UI/VModal.vue";

export default {
  name: "UnreadNewsPopup",
  components: {
    VModal
  },
  mixins: [],
  inject: ["doApiRequest"],
  props: {
    userId: Number,
  },
  data() {
    return {
      unreadNewsItems: [],
      fetchingUnreadNews: false,
      showPopup: false,
    }
  },
  computed: {},
  methods: {
    async checkForUnreadNews() {
      await this.fetchUnreadNews();

      if (this.unreadNewsItems.length > 0) {
        //todo: show popup with first unread article
      }
    },
    async fetchUnreadNews() {
      if (this.fetchingUnreadNews) return;

      try {
        this.fetchingUnreadNews = true;
        this.unreadNewsItems = await this.doApiRequest(
            () => new NewsApi().getUnreadNewsItems());
      } catch (e) {
        log.error(e);

        // TODO - handle error
      } finally {
        this.fetchingUnreadNews = false;
      }
    }
  },
  mounted() {
    this.checkForUnreadNews();
  }
}
</script>

<style scoped lang="scss">

</style>